import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    justifyContent: "space-between",
  },
  headerInfo: {
    flexDirection: "row",
    justifyContent: "center",
  },

  value: {
    textAlign: "center",
    fontSize: 28,
    color: "#077A97",
  },
  dateContainer: {
    marginTop: 12,
    justifyContent: 'center',
    alignItems: "center",
  },

  bold: {
    color: "#077A97",
    fontWeight: "bold",
    fontSize: 16,
  },

  explanationText: {
    textAlign: "center",
    marginVertical: 16,
  },

  codeContainer: {
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
    maxWidth: 400,
    padding: 6,
    justifyContent: 'center',
    borderWidth: 0.5,
    borderColor: '#077A97',
    borderRadius: 4,
    marginBottom: 12,
    flexWrap:'wrap'
  },

  openButton: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 16,
  },

  img: {
    width: 24,
    height: 24,
    tintColor: '#077A97',
  },
  
  codeHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  copyText: {
    marginLeft: 4,
    color: "#256df4",
    fontSize: 16,
  },
  activityIndicatorContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },

  title: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 18,
    color: "#077A97",
    marginBottom: '2%',
  },

  actionButton: {
    padding: 10,
    maxWidth: 320,
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
  },

  actionButtonText: {
    textTransform: "uppercase",
    letterSpacing: 1,
    color: "#fff",
  },
});
